import { getSectionColorScheme } from "./colorModeUtils"
import { getReviewHeroBackgroundColor } from "./reviewHeroUtils"

export const NON_FULL_IMAGE_LAYOUTS = [
  "scattered_images",
  "image_left",
  "image_right",
  "half_image_left",
  "half_image_right",
  "overlap_double_image"
]

export const getReviewHeroPrimaryImageUrl = (section) => {
  const settings = section?.settings || {}
  return section?.imageUrl || settings.images?.[0]?.url || null
}

export const getReviewHeroSectionBackgroundColor = (section, theme, { useHeroImage = false } = {}) => {
  if (useHeroImage) return "transparent"

  const settings = section?.settings || {}
  const colorScheme = getSectionColorScheme(settings, theme)

  if (settings.colorMode) {
    return colorScheme.sectionBackground
  }

  return getReviewHeroBackgroundColor({ section, theme, useHeroImage: false })
}

export const getReviewHeroTextColor = ({
  layout,
  hasBackgroundImage = false,
  theme,
  isInWhiteContainer = false,
  settings = {},
  useHeroImage = false
} = {}) => {
  const colorScheme = getSectionColorScheme(settings, theme)
  const colorMode = colorScheme.colorMode

  if (isInWhiteContainer) {
    return theme?.colors?.textDark || "#000000"
  }

  if (hasBackgroundImage || useHeroImage || layout === "contained_image") {
    return theme?.colors?.textLight || "#F4ECE9"
  }

  if (NON_FULL_IMAGE_LAYOUTS.includes(layout) && colorMode === "dark") {
    return theme?.colors?.textLight || "#FFFFFF"
  }

  return colorScheme.headingColor || theme?.colors?.textDark || "#000000"
}

export const reviewHeroHeaderSyncStyle = (backgroundColor) => `
  .website-builder-v2-public header,
  .website-builder-v2-public nav,
  .website-builder-v2-public .header-section,
  .website-builder-v2-public .header-section-desktop,
  .website-builder-v2-public .header-section-mobile,
  .website-builder-v2 header,
  .website-builder-v2 nav,
  .website-builder-v2 .header-section,
  .website-builder-v2 .header-section-desktop,
  .website-builder-v2 .header-section-mobile,
  .header-section,
  .header-section-desktop,
  .header-section-mobile,
  header,
  nav {
    background-color: ${backgroundColor} !important;
  }
`

export { getReviewHeroLayout, getReviewHeroOverlayOpacity, getReviewHeroImageUrl } from "./reviewHeroUtils"
